//PROGRAMA
export const AGREGAR_PERSONAS_CURSO = 'agregarPersonasCurso';
export const AGREGAR_PERSONAS = 'agregarPersonas';
export const AGREGAR_EMPRESA = 'agregarEmpresa';
export const AGREGAR_CREAR_CURSO = 'crearCurso';

export const VER_PANEL_ADMIN = 'vista_admin';
export const VER_PANEL_COORDINADOR = "ver_panel_coordinador";